export default __webpack_public_path__ + "static/media/supplier_popup_heb.a7aa9b3e.svg";